export enum ErrorCodes {
	NO_FAMILY_OVERVIEW = 'NO_FAMILY_OVERVIEW',
	NO_FAMILY_LIST = 'NO_FAMILY_LIST',
	INVALID_FAMILY_PERFORMANCE_RESPONSE = 'Invalid API response for family performance data',
	INVALID_FAMILY_OVERVIEW_RESPONSE = 'Invalid API response for family overview data',
	LATEST_HOLDINGS_DATA_ERROR = 'Missing family holding or overview data in store',
	NO_FILTER_CONFIG = 'No filters config',
	INVALID_FAMILY_ESG_RESPONSE = 'Invalid API response for family esg data'
}
